// Rota da tela de verificação (`spec/17-frontend.md` §8.1, WEB-07). A tela mora em
// `features/kyc/`; o arquivo de rota só registra o caminho.

import { createFileRoute } from '@tanstack/react-router';
import { KycScreen } from '../features/kyc/wizard.tsx';

export const Route = createFileRoute('/app/settings/kyc/')({ component: KycScreen });
